export default __webpack_public_path__ + "static/media/Ogoumond.5478c904.jpg";